<template>
  <v-card max-width="600" class="mx-auto mt-2">
    <v-card-title>
      Zmień hasło
    </v-card-title>
    <v-card-text>
      <v-text-field label="Aktualne hasło" type="password" outlined required :rules="rules.currentPassword" v-model="itemVm.currentPassword"></v-text-field>
      <v-text-field label="Nowe hasło" type="password" outlined required :rules="rules.newPassword" v-model="itemVm.newPassword"></v-text-field>
      <v-text-field label="Potwierdz hasło" type="password" outlined required :rules="rules.confirmPassword" v-model="itemVm.confirmPassword"></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="changePassword" color="primary" block>Zapisz</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>

import {showError, showInfo} from "@/helpers";
export default {
  data(){
    return {
      itemVm: {
        currentPassword:"",
        newPassword:"",
        confirmPassword:"",
      },
      rules:{
        currentPassword:[
          v => !!v || 'Pole wymagane'
        ],
        newPassword:[
          v => !!v || 'Pole wymagane',
          v => (v && v.length >= 8) || 'Minimalna dlugość hasła to 8 znaków' 
        ],
        confirmPassword:[
          v => !!v || 'Pole wymagane',
          v => (v && v == this.itemVm.newPassword) || 'Hasła nie są zgodne'
        ],
      }
    }
  },
  methods:{
    async changePassword(){
      try {
        const {data} = await this.$http.post("Authentication/ChangePassword", this.itemVm)
        if (data){
          showInfo("Hasło zostało zmienione")
        }
        this.$store.dispatch("logout")
      }
      catch (error) {
        showError("Wprowadzono nieprawidłowe dane")
      }
    }
  }
};
</script>